(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hinomi-sticky-top-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const setup = (root) => {
      if (root.dataset.hstbReady === 'true') return;
      root.dataset.hstbReady = 'true';

      const safeQueryAll = (selector) => {
        try {
          return selector ? Array.from(document.querySelectorAll(selector)) : [];
        } catch (error) {
          return [];
        }
      };

      const trigger = safeQueryAll(root.dataset.triggerSelector)[0];
      const links = Array.from(root.querySelectorAll('.hstb__nav a'));
      const scrollTopButton = root.querySelector('[data-hstb-scroll-top]');
      const scrollGap = Math.max(0, Number(root.dataset.scrollGap) || 0);
      const scrollBehavior = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const targets = links.map((link) => {
        try {
          return document.querySelector(link.getAttribute('href'));
        } catch (error) {
          return null;
        }
      });

      const headerBottom = () => {
        const bottoms = safeQueryAll(root.dataset.headerSelector).map((element) => {
          const rect = element.getBoundingClientRect();
          return rect.height > 0 && rect.bottom > 0 ? Math.min(rect.bottom, window.innerHeight) : 0;
        });
        return Math.max(0, ...bottoms);
      };

      const scrollOffset = () => Math.ceil(
        headerBottom() + root.getBoundingClientRect().height + scrollGap
      );

      let frame;
      const update = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const offset = Math.round(headerBottom());
          const passedTrigger = trigger
            ? trigger.getBoundingClientRect().bottom <= offset + 1
            : window.scrollY > window.innerHeight * .7;
          root.style.setProperty('--hstb-top', `${offset}px`);
          root.classList.toggle('is-visible', passedTrigger);
          root.setAttribute('aria-hidden', String(!passedTrigger));

          const marker = scrollOffset();
          targets.forEach((target) => {
            if (target) target.style.scrollMarginTop = `${marker}px`;
          });
          let activeIndex = 0;
          targets.forEach((target, index) => {
            if (target && target.getBoundingClientRect().top <= marker) activeIndex = index;
          });
          links.forEach((link, index) => link.classList.toggle('is-active', index === activeIndex));
        });
      };

      links.forEach((link, index) => {
        link.addEventListener('click', (event) => {
          const target = targets[index];
          if (!target) return;
          event.preventDefault();
          const top = window.scrollY + target.getBoundingClientRect().top - scrollOffset();
          window.scrollTo({ top, behavior: scrollBehavior() });
        });
      });

      if (scrollTopButton) {
        scrollTopButton.addEventListener('click', (event) => {
          event.preventDefault();
          window.scrollTo({ top: 0, behavior: scrollBehavior() });
        });
      }

      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      if (window.ResizeObserver) {
        const observer = new ResizeObserver(update);
        observer.observe(root);
        if (trigger) observer.observe(trigger);
        safeQueryAll(root.dataset.headerSelector).forEach((header) => observer.observe(header));
      }
      update();
      window.setTimeout(update, 500);
      window.setTimeout(update, 1500);
    };

    const initialize = () => document.querySelectorAll('[data-hstb]').forEach(setup);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
